import { Component, OnInit } from '@angular/core';
import { ExamsService } from '../exams.service';

/**
 * Pulling the answers of the patient's earlier Clinics exam (same template) into
 * the exam that is open.
 *
 * - A freshly started exam checks quietly in the background and, if there is an
 *   earlier one, asks once whether to pull it.
 * - Whenever an earlier exam exists, a button stays on the page so the doctor can
 *   change their mind later. That path warns first, because pulling replaces what
 *   has been written in this exam.
 *
 * The copy of answers, diagnoses and notes happens on the server; the pages that
 * show them listen to ExamsService.clinicPrefilled$ and reload.
 */
@Component({
  selector: 'app-clinic-previous-exam',
  templateUrl: './clinic-previous-exam.component.html',
  styleUrls: ['./clinic-previous-exam.component.scss'],
  standalone: false
})
export class ClinicPreviousExamComponent implements OnInit {
  previous: { examID: number; creationTime: string } = null;
  showPrompt = false;
  showConfirm = false;
  copying = false;
  failed = false;

  constructor(public es: ExamsService) {}

  ngOnInit() {
    // set by startExam for a Clinics exam that was just opened
    const justStarted = this.es.clinicPromptPending;
    this.es.clinicPromptPending = false;
    this.findPrevious(justStarted);
  }

  private findPrevious(prompt: boolean) {
    if (!this.es.examID) return;
    try {
      this.es.getPreviousClinicExam(this.es.examID).subscribe(
        (data: any) => {
          if (data && data.examID) {
            this.previous = data;
            this.showPrompt = prompt;
          }
        },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  /** first-open popup */
  promptYes() {
    this.showPrompt = false;
    this.pull();
  }
  promptNo() {
    this.showPrompt = false;
  }

  /** the side button: warn, then pull */
  askPull() {
    this.failed = false;
    this.showConfirm = true;
  }
  confirmYes() {
    this.showConfirm = false;
    this.pull();
  }
  confirmNo() {
    this.showConfirm = false;
  }

  private pull() {
    if (!this.previous || this.copying) return;
    this.copying = true;
    this.failed = false;
    try {
      this.es.copyPreviousClinicExam(this.es.examID, this.previous.examID).subscribe(
        () => {
          this.copying = false;
          this.es.clinicPrefilled$.next(this.previous.examID);
        },
        (err) => {
          console.log(err);
          this.copying = false;
          this.failed = true;
        }
      );
    } catch (e) {
      console.log(e);
      this.copying = false;
      this.failed = true;
    }
  }
}
